import { scoreColor, scoreHex } from '@/client/lib/colors'

/** Circular SEO score badge (0-100) with colour coding */
export function SeoScoreBadge({
  score,
  size = 'md',
}: {
  score: number | null
  size?: 'sm' | 'md' | 'lg'
}) {
  if (score === null || score === undefined) {
    return (
      <span className="text-xs text-muted-foreground">-</span>
    )
  }

  const color = scoreColor(score)
  const ringColor = scoreHex(score)

  const dims = size === 'sm' ? 'h-8 w-8' : size === 'lg' ? 'h-14 w-14' : 'h-10 w-10'
  const textSize = size === 'sm' ? 'text-[10px]' : size === 'lg' ? 'text-base' : 'text-xs'

  const angle = (score / 100) * 360

  return (
    <div
      className={`${dims} rounded-full flex items-center justify-center shrink-0`}
      style={{
        background: `conic-gradient(${ringColor} ${angle}deg, hsl(var(--muted)) ${angle}deg)`,
      }}
      title={`SEO Score: ${score}/100`}
    >
      <div className="bg-background rounded-full flex items-center justify-center" style={{ width: '80%', height: '80%' }}>
        <span className={`${textSize} ${color} font-bold tabular-nums`}>{score}</span>
      </div>
    </div>
  )
}
